import React from "react";
import { Field, reset, reduxForm } from "redux-form";

let CreateTodo = (props) => {
  const { handleSubmit } = props;
  return (
    <form className="form form--horizontal" onSubmit={handleSubmit}>
      <Field name="title" component="input" type="text" />
    </form>
  );
};

export default reduxForm({
  form: "createUserOnboarding", // a unique identifier for this form
  onSubmitSuccess: (result, dispatch) =>
    dispatch(reset("createUserOnboarding")),
})(CreateTodo);
